(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.vueinview = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict'
var inView = require('in-view')
var shortid = require('shortid')
/**
  * return boolen
    - check typeof object
**/
var isDefine = function (v) { return typeof v !== 'undefined' },
isString = function (v) { return typeof v === 'string' },
isNumber = function (v) { return typeof v === 'number' },
isFunc   = function (v) { return typeof v === 'function' },
isArray  = function (v) { return Array.isArray(v) },
isObject = function (v) { return !isArray(v) && typeof v === 'object' }

// new object function
// for unsupport classList
var nativeClasList = function (el) {
  var className = el.className
  var listClass = className.split(' ')
  this.classList = listClass
  this.el = el
}
nativeClasList.prototype.get = function () {
  return this.classList
}
nativeClasList.prototype.add = function (className) {
  var classList = this.classList
  if (classList.indexOf(className) == -1) {
    classList.push(className)
    this.el.className = classList.join(' ')
  }
}


nativeClasList.prototype.remove = function (className) {
  var classList = this.classList
  if (classList.indexOf(className) >= 0) {
    var index = classList.indexOf(className)
    classList.splice(index, 1)
    this.el.className = classList.join(' ')
  }
}
// define classList object
var _classList = function (el) {
  this.el = el
  if(typeof el.classList !== 'undefined') {
    // if classList support
    this.old = false
  } else {
    // browser class unsupport classList
    this.classList = new nativeClasList(el)
    this.old = true
  }
}
// add classList
_classList.prototype.add = function (className) {
  if (this.old) {
    this.classList.add(className)
    return
  }
  if (!this.hasClass(className)) {
    this.el.classList.add(className)
  }
}
// remove classList
_classList.prototype.remove = function (className) {
  if (this.old) {
    this.classList.remove(className)
    return
  }
  if (this.hasClass(className)) {
    this.el.classList.remove(className)
  }
}
// get Class List
_classList.prototype.get = function () {
  if (this.old) {
    return this.classList.get()
  }
  return this.el.classList
}
_classList.prototype.hasClass = function (className) {
  var classNames = this.el.className
  var listClass = classNames.split(' ')
  if(listClass.indexOf(className) >= 0) {
    return true
  }
  return false
}

var classList = function (el) { return new _classList(el) }
/**
  * return boolen
    - check if key has in object
**/
var hasKey = function (obj, src) {
  var result = false
  var key
  for (key in obj) {
    if (obj.hasOwnProperty(key) && key === src) result = true
  }
  return result
}

/**
  * return number
    - counting key of object
**/
var objLength = function (v) {
  var result = 0
  var key
  for (key in v) {
      v.hasOwnProperty(key) && result++
  }
  return result
}
/**
  * return number
    - check element class
**/
var hasClass = function (el, check) {
  var cls = el.classList
  var size = cls.length
  var result = false
  var i = 0
  for (i; i < size; i++) {
    if (cls[i].toString() === check) result = true
  }
  return result
}
/**
  * return object{is → boolen, count → number}
    - check object has defined in array
**/
var hasObj_Array = function (v, search, val) {
  var defined = Object.create(null)
  defined.is = false
  defined.count = 0
  var length = v.length
  var i
  for (i = 0; i < length; i++) {
    if (isDefine(v[i][search])) {
      if (isDefine(val) && v[i][search] === val) {
        defined.is = true
        defined.count += 1
      }
    }
  }
  return defined
}

// count* → number
var countEntered = 0
var countExits = 0

/**
  * return object{$enter → array, $exits → array, enter → string, exit → string, register → array, values → object{}}
    - create object
**/
var createEl = Object.create(null)
createEl.$enter = []
createEl.$exits = []
createEl.enter = ''
createEl.exit = ''
createEl.register = []
createEl.values = {}

/**
  * (el → dom, classid → string)
    - add element has enter
**/
var _element_enter = function (el, classid) {
  createEl.enter = el
  var cElm_exits = createEl.$exits.length

  // remove element if has in createEl.$exits
  var i
  if (cElm_exits > 0) {
    for (i = 0;i < cElm_exits; i++) {
      // make sure that element is exits
      if (isDefine(createEl.$exits[i]) && isDefine(createEl.$exits[i].class) && createEl.$exits[i].class === classid) {
        createEl.$exits.splice(i,1)
      }
    }
  }

  // push an element
  if (!hasObj_Array(createEl.$enter, 'class', classid).is) createEl.$enter.push({class: classid, el: el})
}

/**
  * (el → dom, classid → string)
    - add element has exit
**/
var element_exit = function (el, classid) {
  createEl.exit = el
  var cElm_enter = createEl.$enter.length

  // remove element if has in createEl.$enter
  var i
  if (cElm_enter > 0) {
    for (i = 0;i < cElm_enter; i++) {
      if (isDefine(createEl.$enter[i]) && isDefine(createEl.$enter[i].class) && createEl.$enter[i].class === classid) {
        createEl.$enter.splice(i,1)
      }
    }
  }

  // push an element
  if (!hasObj_Array(createEl.$exits, 'class', classid).is) createEl.$exits.push({class: classid, el: el})
}

/**
  * (rw → string)
  * return string
    - check and get class ID
**/
var obsclassreg = function (rw) {
  var result
  var rgsize = createEl.register.length
  var i
  for (i = 0;i < rgsize; i++) {
    if (createEl.register[i].rawName === rw) result = createEl.register[i].classid
  }
  return result
}
/**
  * (css → string)
  * return string
    - create javascript stylesheet name
**/
var cssjs = function (css) {
  css = css.split('-')
  var result = css[0] === 'float' ? 'cssFloat' : css[0]
  var size = css.length
  var i
  for (i = 0; i < size; i++) {
    if (i > 0) result += css[i].charAt(0).toUpperCase() + css[i].substr(1)
  }
  return result
}

/**
  * return object
    - define vue-inview object
**/
var vue_inview = function () {}

/**
  * (arg → string, classId → string, callback → function)
    - register inView handler
**/
var _$eventview = function (arg, classId, callback) {
  var view = inView('.' + classId)
  arg === 'on' ? view.on('enter', callback.enter).on('exit', callback.exit) :
  arg === 'once' ? view.once('enter', callback.enter).once('exit', callback.exit) :
  console.warn('[in-view] event handler not found')
}

/**
  * ($m → object{*})
  * return string
    - convert modifiers object as string
**/
var object_modifiers = function ($m) {
  var convert
  var key
  for (key in $m) {
    if ($m.hasOwnProperty(key) && $m[key] === true) {
      if (isDefine(convert)) convert += '.' + key
      else convert = key
    }
  }
  return convert
}

/**
  * (arg → string)
  * return string
    - check and get argument
**/
var $arg = function (arg) {
  var result
  switch (arg) {
    case 'on':
      result = arg
      break
    case 'once':
      result = arg
      break
    case 'class':
      result = arg
      break
    case 'style':
      result = arg
      break
    case 'enter':
      result = arg
      break
    case 'leave':
      result = arg
      break
    case 'animate':
      result = arg
      break
    case 'parent':
      result = arg
      break
    default:
      console.warn('[in-view] argument ${arg} undefined')
  }
  return result
}

/**
  * (bidd → object{arg → string, modifiers → array}, callback → function)
    - check and call callback action
**/
var defaultAction = function (bidd, callback) {
  if (!isDefine(bidd.arg)) callback()
  if (bidd.arg === 'on' || bidd.arg === 'once' && objLength(bidd.modifiers) === 0) callback()
}

/**
  * (clss → string | object | array, el → dom)
    - add and remove class of element
**/
var object_class = function (clss, el) {
  if (isString(clss)) classList(el).add(clss)
  if (isObject(clss)) {
    var classArr = el.className.split(' ')
    var key
    for (key in clss) {
      if (classArr.indexOf(key) && clss[key] === false) classList(el).remove(key)
      if (clss.hasOwnProperty(key) && clss[key] === true) classList(el).add(key)
    }
  }
  if (isArray(clss)) {
    var i
    for (i = 0;i < clss.length; i++) {
      classList(el).add(clss[i])
    }
  }
}

/**
  * (css →  object | array, el → dom)
    - add and remove style of element
**/
var object_style = function (css, el) {
  var style = el.style
  if (isObject(css)) {
    var key
    for (key in css) {
      if (isDefine(style[cssjs(key)])) style[cssjs(key)] = css[key]
    }
  }
  if (isArray(css)) {
    var size = css.length
    var i
    for (i = 0; i < size; i++){
      if (isDefine(style[cssjs(css[i])])) style[cssjs(css[i])] = ""
    }
  }
}

/**
  * (animateClass → array)
    - defined all animation
**/
var animateClass = [
  'bounce', 'flash', 'pulse', 'rubberBand', 'shake', 'headShake', 'swing', 'tada',
  'wobble', 'jello', 'bounceIn', 'bounceInDown', 'bounceInLeft', 'bounceInRight',
  'bounceInUp', 'bounceOut', 'bounceOutDown', 'bounceOutLeft', 'bounceOutRight',
  'bounceOutUp', 'fadeIn', 'fadeInDown', 'fadeInDownBig', 'fadeInLeft', 'fadeInLeftBig',
  'fadeInRight', 'fadeInRightBig', 'fadeInUp', 'fadeInUpBig', 'fadeOut', 'fadeOutDown',
  'fadeOutDownBig', 'fadeOutLeft', 'fadeOutLeftBig', 'fadeOutRight', 'fadeOutRightBig',
  'fadeOutUp', 'fadeOutUpBig', 'flipInX', 'flipInY', 'flipOutX', 'flipOutY', 'lightSpeedIn',
  'lightSpeedOut', 'rotateIn', 'rotateInDownLeft', 'rotateInDownRight', 'rotateInUpLeft', 'rotateInUpRight',
  'rotateOut', 'rotateOutDownLeft', 'rotateOutDownRight', 'rotateOutUpLeft', 'rotateOutUpRight',
  'hinge', 'jackInTheBox', 'rollIn', 'rollOut', 'zoomIn', 'zoomInDown', 'zoomInLeft', 'zoomInRight',
  'zoomInUp', 'zoomOut', 'zoomOutDown', 'zoomOutLeft', 'zoomOutRight', 'zoomOutUp', 'slideInDown', 'slideInLeft',
  'slideInRight', 'slideInUp', 'slideOutDown', 'slideOutLeft', 'slideOutRight', 'slideOutUp'
]

/**
  * (data → string)
    - generate inverse direction
**/
var animate_inverse = function (data) {
  var inverse = [
    ['In', 'Out'],
    ['X', 'Y'],
    ['Down', 'Up'],
    ['Left', 'Right']
  ]
  var i = 0
  var size = inverse.length
  var result
  for (i; i < size; i++) {
    var index = inverse[i]
    if (index.indexOf(data) >= 0) {
      var colm = index.indexOf(data)
      result = colm === 0 ? index[1] : index[0]
    }
  }
  return result
}

/**
  * (an → string, type → string)
    - generate animation direction
**/
var animate_direction = function (an, type) {
  var data = an
  var animate
  var result

  if (/^[a-z]+[A-Z][a-z]+$/.test(data)) {
    animate = data.match(/^([a-z]+)([A-Z][a-z]+)$/)
    if (type === 'toggle' && isDefine(animate_inverse(animate[2]))) {
      result = animate[1] + animate_inverse(animate[2])
    }
  }
  if (/^[a-z]+[A-Z][a-z]+[A-Z]$/.test(data)) {
    animate = data.match(/^([a-z]+)([A-Z][a-z]+)([A-Z])$/)
    if (type === 'toggle' && isDefine(animate_inverse(animate[2]))) {
      result = animate[1] + animate_inverse(animate[2])  + animate[3]
    }
    if (type === 'toggle.inverse' && isDefine(animate_inverse(animate[2]))) {
      var direct = isDefine(animate_inverse(animate[3])) ? animate_inverse(animate[3]) : animate[3]
      result = animate[1] + animate_inverse(animate[2])  + direct
    }
  }
  if (/^[a-z]+[A-Z][a-z]+[A-Z][a-z]+$/.test(data)) {
    animate = data.match(/^([a-z]+)([A-Z][a-z]+)([A-Z][a-z]+)$/)
    if (type === 'toggle' && isDefine(animate_inverse(animate[2]))) {
      result = animate[1] + animate_inverse(animate[2])  + animate[3]
    }
    if (type === 'toggle.inverse' && isDefine(animate_inverse(animate[2]))) {
      var direct = isDefine(animate_inverse(animate[3])) ? animate_inverse(animate[3]) : animate[3]
      result = animate[1] + animate_inverse(animate[2])  + direct
    }
  }
  if (/^[a-z]+[A-Z][a-z]+[A-Z][a-z]+[A-Z][a-z]+$/.test(data)) {
    animate = data.match(/^([a-z]+)([A-Z][a-z]+)([A-Z][a-z]+)([A-Z][a-z]+)$/)
    if (type === 'toggle' && isDefine(animate_inverse(animate[2]))) {
      result = animate[1] + animate_inverse(animate[2])  + animate[3]
    }
    if (type === 'toggle.inverse' && isDefine(animate_inverse(animate[2]))) {
      var direct = isDefine(animate_inverse(animate[3])) ? animate_inverse(animate[3]) : animate[3] +
      isDefine(animate_inverse(animate[4])) ? animate_inverse(animate[4]) : animate[4]
      result = animate[1] + animate_inverse(animate[2])  + direct
    }
  }
  return result
}

/**
  * (el →  dom, callback → function)
    - looping querySelectorAll
**/
var element_looping = function (el, callback) {
  var size = el.length
  var i = 0
  for (i; i < size; i++) {
    callback(el[i], i)
  }
}
/**
  * (cls → string | array, el → dom, mdf → string)
    - inview animation handler
**/
var object_animation = function (cls, el, mdf) {
  var display = el.getAttribute('animate-display')
  if (display !== null) {
    el.style.display= dispay
  } else {
    var none = el.getAttribute('animate-display-none')
    if (none === null || none !== 'false') {
      el.style.display= 'block'
    }
  }
  if (isString(cls)) {
    if (isDefine(mdf)) {
      var inverseAnim = animate_direction(cls, mdf)
      if (isDefine(inverseAnim) && classList(el).hasClass(inverseAnim)) {
        var rmClass = {}
        rmClass[inverseAnim] = false
        object_class(rmClass, el)
      }
    }
    var hasToggling = false
    if (classList(el).hasClass(cls)) {
      hasToggling = true
      var rmClass = {}
      rmClass[cls] = false
      object_class(rmClass, el)
    }
    if (isDefine(mdf) && hasToggling) {
      var inverseAnim = animate_direction(cls, mdf)
      if (isDefine(inverseAnim)){
        object_class(inverseAnim, el)
      }
    } else {
      var animate = !classList(el).hasClass('animated') ? ['animated', cls] : cls
      object_class(animate, el)
    }
  }
  if (isArray(cls)) {
    var i = 0
    var size = cls.length
    var iClass
    var animate
    for (i; i < size; i++) {
      if (classList(el).hasClass(cls[i])) {
        var rmClass = {}
        rmClass[cls[i]] = false
        iClass = i
        object_class(rmClass, el)
      }
    }
    if (isDefine(mdf) && mdf === 'toggle') {
      var getClass = isDefine(iClass) && size > 0 && (iClass + 1) < size ?  cls[(iClass + 1)] : cls[0]
      animate = !classList(el).hasClass('animated') ? ['animated', getClass] : getClass
    } else {
      animate = !classList(el).hasClass('animated') ? cls.push('animated') : cls
    }
    object_class(animate, el)
  }
}
/**
  * (el → dom)
    - check and get animation attribute
**/
var animate_attribute = function (el) {
  var normal = el.querySelectorAll('[animate]')
  var toggle = el.querySelectorAll('[animate-toggle]')
  var inverse = el.querySelectorAll('[animate-toggle-inverse]')
  if (normal !== null) element_looping(normal, function (els) {
    var attr = els.getAttribute('animate')
    object_animation(attr, els)
  })
  if (toggle !== null) element_looping(toggle, function (els) {
    var attr = els.getAttribute('animate-toggle')
    object_animation(attr, els, 'toggle')
  })
  if (inverse !== null) element_looping(inverse, function (els) {
    var attr = els.getAttribute('animate-toggle-inverse')
    object_animation(attr, els, 'toggle.inverse')
  })
}

/**
  * (parent → string, el → dom)
    - inview directive handler
**/
var object_parent = function (parent, el) {
  if (parent === 'animate') animate_attribute (el)
}

/**
  * (el → dom, $bd → object{*})
    - inview directive handler
**/
var _$elinview = function (el, $bd) {

  // generate class indetities
  // add prefix , number can't been the first character in classname
  var classId = "inview-" + shortid.generate()
  var elSize = classList(el).get().length

  // register class element
  classList(el).add(classId)
  createEl.register.push({classid: classId,rawName: $bd.rawName})

  // if directive value not registed
  if (!hasKey(createEl.values, classId) && isDefine($bd.value)) createEl.values[classId] = $bd.value

  // register handler
  var regHdlr = !isDefine($bd.arg) ? 'on' : isDefine($arg($bd.arg)) && $arg($bd.arg) === 'once' ? 'once' : isDefine($arg($bd.arg)) ?
                'on' : 'undefined'

  // create Object for handling element enter and exit
  var funcEvent = Object.create(null)

  // default event handler
  defaultAction($bd, function () {
    if (isDefine(createEl.values[classId]) && isFunc(createEl.values[classId])) createEl.values[classId](funcEvent)
  })
  var _$arg = isDefine($arg($bd.arg)) && $arg($bd.arg) !== 'on' || $arg($bd.arg) === 'once' ? $arg($bd.arg) : 'undefined'
  _$eventview(regHdlr,classId,{
    enter: function(el) {
      var elvalue
      // check the value of the directive has been registered
      if(hasKey(createEl.values,classId)) elvalue = createEl.values[classId]

      // for magic properties
      countEntered += 1
      _element_enter(el, classId)
      // end magic properties

      if (_$arg !== 'undefined' && objLength($bd.modifiers) === 0 && isDefine(elvalue)){
          _$arg === 'class' && object_class(elvalue, el)
          _$arg === 'style' && object_style(elvalue, el)
          _$arg === 'animate' && object_animation(elvalue, el)
          _$arg === 'parent' && object_parent(elvalue, el)
          if (_$arg === 'enter') isFunc(elvalue) ? elvalue(el) : console.warn('[in-view:${$bd.expression}] invalid method')
      }


      if (_$arg === 'on' || _$arg === 'once' && objLength($bd.modifiers) > 0 && isDefine(elvalue)){
        // register modifiers
        var $mdf = object_modifiers($bd.modifiers)
        // modifiers enter
        if ($mdf === 'enter') isFunc(elvalue) ? elvalue(el) : console.warn('[in-view:${$bd.expression}] invalid method')
        // modifiers class
        $mdf === 'class' && object_class(elvalue, el)
        // modifiers style
        $mdf === 'style' && object_style(elvalue, el)
        // modifiers animate
        $mdf === 'animate' && object_animation(elvalue, el)
        // set parent arguments
        $mdf === 'parent' && object_parent(elvalue, el)
      }

      isDefine(funcEvent.enter) && funcEvent.enter(el)
    },
    exit: function (el) {
      var elvalue

      // check the value of the directive has been registered
      if (hasKey(createEl.values,classId)) elvalue = createEl.values[classId]
      // for magic properties
      countExits += 1
      element_exit(el,classId)
      // end magic properties

      if (_$arg !== 'undefined' && isDefine(elvalue)) {
        if (_$arg === 'leave' && objLength($bd.modifiers)===0) isFunc(elvalue) ? elvalue(el) : console.warn('[in-view:${$bd.expression}] invalid method')
        if (objLength($bd.modifiers) > 0 && object_modifiers($bd.modifiers) === 'leave') {
          _$arg === 'class' && object_class(elvalue,el)
          _$arg === 'style' && object_style(elvalue,el)
          _$arg === 'animate' && object_animation(elvalue,el)
          _$arg === 'parent' && object_parent(elvalue, el)
        }
        if (_$arg === 'parent' && objLength($bd.modifiers) === 0) {
          object_parent(elvalue, el)
        }
      }

      // check if has modifiers
      if (_$arg === 'on' || _$arg === 'once' && objLength($bd.modifiers)>0 && isDefine(elvalue)) {
        // register modifiers
        var $mdf = object_modifiers($bd.modifiers)
        // modifiers leave
        if ($mdf === 'leave') isFunc(elvalue) ? elvalue(el) : console.warn('[in-view:${$bd.expression}] invalid method')
        // leave : class modifiers
        $mdf === 'class.leave' && object_class(elvalue,el)
        // leave : style modifiers
        $mdf === 'style.leave' && object_style(elvalue,el)
        // leave : animate modifiers
        $mdf === 'animate.leave' && object_animation(elvalue,el)
        // set parent arguments
        $mdf === 'parent' && object_parent(elvalue, el)
      }
      isDefine(funcEvent.exit) && funcEvent.exit(el)
    }
  })
}

/**
  * return object{ inserted → function(*), componentUpdated: function(*) }
    - directive object
**/
var _directObj = {
  inserted: function (el,$bd) {
    _$elinview(el,$bd)
  },
  componentUpdated: function (el,$bd) {
    var elSize = classList(el).get().length
    var getclass
    // check the class has been registered
    var i
    for (i = 0; i < elSize; i++) {
      if (isDefine(obsclassreg($bd.rawName)) && obsclassreg($bd.rawName)===classList(el).get()[i]) getclass = classList(el).get()[i]
    }
    if (isDefine(getclass) && isDefine($bd.value)) createEl.values[getclass] = $bd.value
  }
}

/**
  * (el → dom, att → string)
  * return boolen
    - check if has attribute
**/
var hasAtt = function (el, att) {
  var result = false
  if (/^\.[\w]+/.test(att)) {
    var className = att.match(/^\.([\w]+)/)[1]
    var gClass = el.className.split(' ')
    if (gClass.indexOf(className)>-1) {
      result = true
    }
  }
  if (/^\#[\w]+/.test(att)) {
    var idName = att.match(/^\#([\w]+)/)[1]
    if (el.hasAttribute('id') && el.getAttribute('id')===idName) result = true
  }
  if (/^\[[\w]+=\"[\w]+\"\]$/.test(att)) {
    var attr = att.match(/^\[([\w]+)=\"([\w]+)\"\]$/)
    var attName = attr[1]
    var attval = attr[2]
    if (el.hasAttribute(attName) && el.getAttribute(attName)===attval) result = true
  }
  if (/^\[[\w]+=\'[\w]+\'\]$/.test(att)){
    var attr = att.match(/^\[([\w]+)=\'([\w]+)\'\]$/)
    var attName = attr[1]
    var attval = attr[2]
    if (el.hasAttribute(attName) && el.getAttribute(attName)===attval) result = true
  }
  return result
}

/**
  * (update → function)
    - life cycle update
**/
var updateLifeCycle = function (update) {
  var sync = function () {
    update()
    setTimeout(sync,0)
  }
  sync()
}

/**
  * ($arg → string, $opt → object{ * })
    - check and send notification if component has enter or exit
**/
var _$inview = function ($arg, $opt) {
  var lastEnter = 0
  var lastExit = 0
  updateLifeCycle(function () {
    if (isDefine($opt) && isObject($opt) && isString($arg)) {
      if (countEntered > lastEnter) {
        isDefine($opt.enter) && hasAtt(createEl.enter, $arg) && $opt.enter(createEl.enter)
        lastEnter = countEntered
      }
      if (countExits > lastExit) {
        isDefine($opt.exit) && hasAtt(createEl.exit,$arg) && $opt.exit(createEl.exit)
        lastExit = countExits
      }
    }
  })
}

/**
  * ($vm → vue Object)
    - set directive
**/
var _directive = function ($vm) {
  $vm.directive('inview', _directObj)
}

/**
  * ($vm → vue Object)
    - set prototype
**/
var _$methods = function ($vm) {
  $vm.prototype._$inview = _$inview
}

var _install = function (Vue, Option) {
  if (isDefine(Option) && isObject(Option)) inView.offset(Option)
  _directive(Vue)
  _$methods(Vue)
}

vue_inview.install = _install

vue_inview.threshold = function (c) {
  inView.threshold(c)
}

vue_inview.offset = function (c) {
  inView.offset(c)
}

module.exports = vue_inview

},{"in-view":2,"shortid":4}],2:[function(require,module,exports){
/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.inView=e():t.inView=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}var i=n(2),o=r(i);t.exports=o["default"]},function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(9),o=r(i),u=n(3),f=r(u),s=n(4),c=function(){if("undefined"!=typeof window){var t=100,e=["scroll","resize","load"],n={history:[]},r={offset:{},threshold:0,test:s.inViewport},i=(0,o["default"])(function(){n.history.forEach(function(t){n[t].check()})},t);e.forEach(function(t){return addEventListener(t,i)}),window.MutationObserver&&addEventListener("DOMContentLoaded",function(){new MutationObserver(i).observe(document.body,{attributes:!0,childList:!0,subtree:!0})});var u=function(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return n.history.indexOf(t)>-1?n[t].elements=e:(n[t]=(0,f["default"])(e,r),n.history.push(t)),n[t]}};return u.offset=function(t){if(void 0===t)return r.offset;var e=function(t){return"number"==typeof t};return["top","right","bottom","left"].forEach(e(t)?function(e){return r.offset[e]=t}:function(n){return e(t[n])?r.offset[n]=t[n]:null}),r.offset},u.threshold=function(t){return"number"==typeof t&&t>=0&&t<=1?r.threshold=t:r.threshold},u.test=function(t){return"function"==typeof t?r.test=t:r.test},u.is=function(t){return r.test(t,r)},u.offset(0),u}};e["default"]=c()},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,r){n(this,t),this.options=r,this.elements=e,this.current=[],this.handlers={enter:[],exit:[]},this.singles={enter:[],exit:[]}}return r(t,[{key:"check",value:function(){var t=this;return this.elements.forEach(function(e){var n=t.options.test(e,t.options),r=t.current.indexOf(e),i=r>-1,o=n&&!i,u=!n&&i;o&&(t.current.push(e),t.emit("enter",e)),u&&(t.current.splice(r,1),t.emit("exit",e))}),this}},{key:"on",value:function(t,e){return this.handlers[t].push(e),this}},{key:"once",value:function(t,e){return this.singles[t].unshift(e),this}},{key:"emit",value:function(t,e){for(;this.singles[t].length;)this.singles[t].pop()(e);for(var n=this.handlers[t].length;--n>-1;)this.handlers[t][n](e);return this}}]),t}();e["default"]=function(t,e){return new i(t,e)}},function(t,e){"use strict";function n(t,e){var n=t.getBoundingClientRect(),r=n.top,i=n.right,o=n.bottom,u=n.left,f=n.width,s=n.height,c={t:o,r:window.innerWidth-u,b:window.innerHeight-r,l:i},a={x:e.threshold*f,y:e.threshold*s};return c.t>e.offset.top+a.y&&c.r>e.offset.right+a.x&&c.b>e.offset.bottom+a.y&&c.l>e.offset.left+a.x}Object.defineProperty(e,"__esModule",{value:!0}),e.inViewport=n},function(t,e){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,function(){return this}())},function(t,e,n){var r=n(5),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){function r(t,e,n){function r(e){var n=x,r=m;return x=m=void 0,E=e,w=t.apply(r,n)}function a(t){return E=t,j=setTimeout(h,e),M?r(t):w}function l(t){var n=t-O,r=t-E,i=e-n;return _?c(i,g-r):i}function d(t){var n=t-O,r=t-E;return void 0===O||n>=e||n<0||_&&r>=g}function h(){var t=o();return d(t)?p(t):void(j=setTimeout(h,l(t)))}function p(t){return j=void 0,T&&x?r(t):(x=m=void 0,w)}function v(){void 0!==j&&clearTimeout(j),E=0,x=O=m=j=void 0}function y(){return void 0===j?w:p(o())}function b(){var t=o(),n=d(t);if(x=arguments,m=this,O=t,n){if(void 0===j)return a(O);if(_)return j=setTimeout(h,e),r(O)}return void 0===j&&(j=setTimeout(h,e)),w}var x,m,g,w,j,O,E=0,M=!1,_=!1,T=!0;if("function"!=typeof t)throw new TypeError(f);return e=u(e)||0,i(n)&&(M=!!n.leading,_="maxWait"in n,g=_?s(u(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),b.cancel=v,b.flush=y,b}var i=n(1),o=n(8),u=n(10),f="Expected a function",s=Math.max,c=Math.min;t.exports=r},function(t,e,n){var r=n(6),i=function(){return r.Date.now()};t.exports=i},function(t,e,n){function r(t,e,n){var r=!0,f=!0;if("function"!=typeof t)throw new TypeError(u);return o(n)&&(r="leading"in n?!!n.leading:r,f="trailing"in n?!!n.trailing:f),i(t,e,{leading:r,maxWait:e,trailing:f})}var i=n(7),o=n(1),u="Expected a function";t.exports=r},function(t,e){function n(t){return t}t.exports=n}])});
},{}],3:[function(require,module,exports){
/**
 * Secure random string generator with custom alphabet.
 *
 * Alphabet must contain 256 symbols or less. Otherwise, the generator
 * will not be secure.
 *
 * @param {generator} random The random bytes generator.
 * @param {string} alphabet Symbols to be used in new random string.
 * @param {size} size The number of symbols in new random string.
 *
 * @return {string} Random string.
 *
 * @example
 * var format = require('nanoid/format')
 *
 * function random (size) {
 *   var result = []
 *   for (var i = 0; i < size; i++) result.push(randomByte())
 *   return result
 * }
 *
 * format(random, "abcdef", 5) //=> "fbaef"
 *
 * @name format
 * @function
 */
module.exports = function (random, alphabet, size) {
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  var step = Math.ceil(1.6 * mask * size / alphabet.length)

  var id = ''
  while (true) {
    var bytes = random(step)
    for (var i = 0; i < step; i++) {
      var byte = bytes[i] & mask
      if (alphabet[byte]) {
        id += alphabet[byte]
        if (id.length === size) return id
      }
    }
  }
}

/**
 * @callback generator
 * @param {number} bytes The number of bytes to generate.
 * @return {number[]} Random bytes.
 */

},{}],4:[function(require,module,exports){
'use strict';
module.exports = require('./lib/index');

},{"./lib/index":8}],5:[function(require,module,exports){
'use strict';

var randomFromSeed = require('./random/random-from-seed');

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};

},{"./random/random-from-seed":11}],6:[function(require,module,exports){
'use strict';

var generate = require('./generate');
var alphabet = require('./alphabet');

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;

},{"./alphabet":5,"./generate":7}],7:[function(require,module,exports){
'use strict';

var alphabet = require('./alphabet');
var random = require('./random/random-byte');
var format = require('nanoid/format');

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;

},{"./alphabet":5,"./random/random-byte":10,"nanoid/format":3}],8:[function(require,module,exports){
'use strict';

var alphabet = require('./alphabet');
var build = require('./build');
var isValid = require('./is-valid');

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = require('./util/cluster-worker-id') || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;

},{"./alphabet":5,"./build":6,"./is-valid":9,"./util/cluster-worker-id":12}],9:[function(require,module,exports){
'use strict';
var alphabet = require('./alphabet');

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;

},{"./alphabet":5}],10:[function(require,module,exports){
'use strict';

var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;

},{}],11:[function(require,module,exports){
'use strict';

// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};

},{}],12:[function(require,module,exports){
'use strict';

module.exports = 0;

},{}]},{},[1])(1)
});
